import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import productDeleteModalStyles from "./ProductDeleteModal.styles";

const VariantDeleteModal = ({ open, onClose, onConfirm, variantIndex }) => {
  const styles = productDeleteModalStyles;

  const handleConfirm = () => {
    onConfirm(variantIndex);
    onClose();
  };

  return (
    <Modal 
      open={open} 
      onClose={(event, reason) => {
        console.log("event", event);
        // Only close on Cancel button click, not on backdrop click
        if (reason === 'backdropClick') {
          return;
        }
        onClose();
      }}
    >
      <Box sx={styles.deleteModalContent}>
        <Typography sx={styles.deleteModalTitle}>
          Delete Variant?
        </Typography>
        <Typography sx={styles.deleteModalText}>
          This action can't be undone. Product variant will be deleted.
        </Typography>
        <Box sx={styles.deleteModalBtns}>
          <Button
            variant='outlined'
            color='primary'
            sx={styles.deleteModalCancelBtn}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            sx={styles.deleteModalYesBtn}
            onClick={handleConfirm}
          >
            Delete
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default VariantDeleteModal;

